// @ts-nocheck
/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Typography from "@insite/mobius/Typography"; // Starter Custom Code
import * as React from "react";
import { connect } from "react-redux";

/* Starter Custom Code */
// import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography"; // Foundation

// Foundation --->
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FieldDefinitionBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import { handleTextAlignment } from "@store/Themes/common/mixins/typography";
import pageTitleProps from "@store/Themes/common/props/pageTitle";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
// <--- Foundation

export interface PageTitleStyles {
    title?: TypographyPresentationProps;
}

export const pageTitleStyles: PageTitleStyles = {
    title: {
        variant: "h1",
    },
};

const styles = pageTitleStyles;
/* Starter Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

// Foundation --->
const enum fields {
    overrideTitle = "overrideTitle",
    useAltFont = "useAltFont",
    useCustomSpacing = "useCustomSpacing",
    customSpacing = "customSpacing",
    hasBorder = "hasBorder",
    alignment = "alignment",
    borderColor = "borderColor",
    borderSide = "borderSide",
    useCustomColor = "useCustomColor",
    customColor = "customColor",
}

export type BorderFieldOptions = {
    [fields.alignment]: "flex-start" | "center" | "flex-end";
    [fields.borderColor]: "secondary" | "common.background";
    [fields.borderSide]: "top" | "down";
    [fields.hasBorder]: boolean;
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.overrideTitle]: string;
        [fields.useCustomSpacing]: boolean;
        [fields.customSpacing]: number;
        [fields.useCustomColor]: boolean;
        [fields.customColor]: string;
    } & FieldDefinitionBuilderOptions<"titleType" | "titleStyle" | "customColor"> &
        BorderFieldOptions;
}
// <--- Foundation

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & OwnProps; // Foundation - OwnProps

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => {
    // Foundation --->
    const textProps: TypographyPresentationProps = {
        ...pageTitleProps,
        variant: fields.titleStyle,
        border: fields.hasBorder
            ? {
                  align: fields.alignment,
                  color: fields.borderColor,
                  side: fields.borderSide,
              }
            : undefined,
        css: css`
            ${pageTitleProps.css}

            ${responsiveCss(
                fields,
                field => css`
                    ${field.useCustomSpacing &&
                    `
                        margin-bottom: ${pxToRem(field.customSpacing)};
                    `}

                    ${fields.useCustomColor &&
                    `
                        color: ${fields.customColor};
                    `}

                    text-align: ${handleTextAlignment(field.alignment)};
                `,
            )}
        `,
    };
    // <--- Foundation

    return (
        <Typography as={fields.titleType} {...textProps /* Foundation */} data-test-selector="PageTitle">
            {fields.overrideTitle || pageTitle}
        </Typography>
    );
};

// Foundation --->
export const titleBorderFieldDefinitions: FieldDefinition[] = [
    {
        name: fields.hasBorder,
        displayName: "Add Border to Title",
        editorTemplate: "CheckboxField",
        defaultValue: true,
        fieldType: "General",
    },
    {
        name: fields.alignment,
        displayName: "Alignment",
        editorTemplate: "DropDownField",
        options: [
            { displayName: "Left", value: "flex-start" },
            { displayName: "Center", value: "center" },
            { displayName: "Right", value: "flex-end" },
        ],
        defaultValue: "flex-start",
        fieldType: "General",
    },
    {
        name: fields.borderColor,
        displayName: "Border Color",
        editorTemplate: "RadioButtonsField",
        options: [
            { displayName: "Orange", value: "secondary" },
            { displayName: "White", value: "white" },
        ],
        defaultValue: "secondary",
        fieldType: "General",
        isVisible: widget => widget.fields.hasBorder,
    },
    {
        name: fields.borderSide,
        displayName: "Border Side",
        editorTemplate: "RadioButtonsField",
        options: [
            { displayName: "Top", value: "top" },
            { displayName: "Bottom", value: "down" },
        ],
        defaultValue: "top",
        fieldType: "General",
        isVisible: widget => widget.fields.hasBorder,
    },
];
// <--- Foundation

const widgetModule: WidgetModule<FoundationFieldDefinition /* Foundation */> = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        // Foundation --->
        fieldDefinitions: [
            {
                name: fields.overrideTitle,
                displayName: "Overriden Title",
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: false,
                fieldType: "General",
            },
            ...fieldDefinitionBuilder(
                [
                    ...titleBorderFieldDefinitions,
                    {
                        name: fields.useCustomSpacing,
                        displayName: "Use Custom Spacing Bottom",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        tooltip: "If not checked, it applies the spacing from base theme",
                        fieldType: "General",
                    },
                    {
                        name: fields.customSpacing,
                        displayName: "Custom Spacing Bottom",
                        editorTemplate: "IntegerField",
                        defaultValue: 0,
                        tooltip: "The Spacing Bottom in Number of Pixels",
                        fieldType: "General",
                        isVisible: widget => widget.fields.useCustomSpacing,
                    },
                ],
                {
                    typographyOptions: {
                        titleStyle: true,
                        titleType: true,
                        useCustomColor: true,
                        customColor: true,
                    },
                },
            ),
            // <--- Foundation
        ],
    },
};

export default widgetModule;
